/**
 * Resolves a single school UUID for scoped API calls.
 * URL param wins; auth fallback only when it is a single id (not comma-separated).
 */
export function resolveSingleSchoolId(
  urlSchoolId?: string | null,
  authSchoolId?: string | null
): string | null {
  const fromUrl = urlSchoolId?.trim();
  if (fromUrl && !fromUrl.includes(",")) {
    return fromUrl;
  }

  const fromAuth = authSchoolId?.trim();
  if (fromAuth && !fromAuth.includes(",")) {
    return fromAuth;
  }

  return null;
}
